<div class="basiq-success-page">
  <div class="content-wrapper">
    <h2>Bank connection successful</h2>

    <div class="info-box success">
      <mat-icon>check_circle</mat-icon>
      <div>
        <strong>Your bank account is now connected.</strong>
        <p>We’ll securely retrieve and analyse your bank statements to progress your application.</p>
      </div>
    </div>

    <div class="section-divider"></div>

    <h3>What happens next</h3>
    <div class="next-steps-card">
      <ul class="steps-list">
        <li>We’ll fetch your latest bank statements through Basiq</li>
        <li>Our system will analyse your statements for assessment</li>
        <li>We’ll notify you if anything else is required</li>
      </ul>
    </div>

    <div class="section-divider"></div>

    <h3>Manage or Stop Sharing Your Data</h3>
    <p>You can easily manage your consent at any time <a [routerLink]="['/basiq/consent']">from here</a></p>
    

    <div class="section-divider"></div>

    <div class="help-section">
      <h3>Need help?</h3>
      <p>If you have any questions, please contact our support team:</p>
      <p><strong>Phone:</strong> 1300 001 420</p>
      <p><strong>Email:</strong> <a href="mailto:support&#64;dynamoney.com"> support&#64;dynamoney.com</a></p>
    </div>

    <div class="footer-container">
      <p>
        For details about how we handle your data, see our
        <a href="/privacy-policy">Privacy Policy</a>
      </p>
    </div>
  </div>
</div>